<nz-modal
  [(nzVisible)]="isModalOpen"
  [nzFooter]="null"
  [nzClosable]="false"
  (nzOnCancel)="closeModal()"
  [nzWrapClassName]="'export-to-excel-modal'"
>
  <ng-container *nzModalContent class="export-to-excel-modal">
    <div class="header">
      <span class="title">Export to Excel</span>
      <va-icon (click)="closeModal()" name="close-circle"></va-icon>
    </div>

    <div class="content">
      <div class="row">
        <button
          (click)="onLastUsedSettingsClicked()"
          nz-button
          nzType="primary"
          nzSize="small"
          class="modal-btns"
        >
          Last Used Export Settings
        </button>
        <span style="font-weight: 600"
          >Build Time:
          <span class="build-complexity-color" [ngClass]="buildTimeClass"
            >{{ buildTimeDisplay }}
          </span>
        </span>
      </div>

      <div class="divider"></div>

      <nz-tabset
        [nzTabPosition]="'left'"
        [nzType]="'line'"
        [nzTabBarGutter]="0"
        [(nzSelectedIndex)]="selectedTabIndex"
        (nzSelectChange)="onSectionTabChanged()"
      >
        <nz-tab
          *ngFor="let tab of tabs; let idx = index"
          [nzTitle]="titleTemplate"
          [nzDisabled]="tab.header"
          class="export-settings-tab"
        >
          <ng-template #titleTemplate>
            <va-icon
              *ngIf="!tab.header"
              size="small"
              [name]="tab.icon"
              class="icon"
            ></va-icon
            >{{ tab.title }}
          </ng-template>
          <ng-template
            *ngIf="idx === 1; then currentSettingsContent"
          ></ng-template>
          <ng-template *ngIf="idx === 3; then statementsContent"></ng-template>
          <ng-template *ngIf="idx === 4; then sourcesContent"></ng-template>
          <ng-template *ngIf="idx === 5; then timeperiodsContent"></ng-template>
          <ng-template
            *ngIf="idx === 6; then historicalEstimatesContent"
          ></ng-template>
          <ng-template *ngIf="idx === 7; then analyticsContent"></ng-template>
        </nz-tab>
      </nz-tabset>

      <div class="divider"></div>
      <div class="row">
        <button
          (click)="onResetClicked()"
          nz-button
          nzType="primary"
          class="modal-btns"
        >
          Reset
        </button>
        <div class="row">
          <button
            nz-button
            nzType="primary"
            (click)="closeModal()"
            class="modal-btns"
          >
            Cancel
          </button>
          <button
            nz-button
            nzType="primary"
            style="background: #36abad"
            (click)="onExportClick()"
            class="modal-btns"
          >
            Export
          </button>
        </div>
      </div>
    </div>

    <!-- ============================================================ -->
    <!-- current settings template start -->
    <!-- ============================================================ -->
    <ng-template #currentSettingsContent>
      <div class="current-settings-content">
        <span class="preset-header">Current Settings</span>
        <div class="divider"></div>
        <div class="content-inner">
          <div class="current-settings-subsection">
            <span class="preset-subheader">Statements:</span>
            <span
              *ngIf="sourcesDataCopy.statements.STD.length > 0"
              nz-tooltip
              nzTooltipTitle="{{ sourcesDataCopy.statements.STD.join(', ') }}"
              nzTooltipPlacement="bottomLeft"
              nzTooltipMouseEnterDelay="14"
              [nzTooltipOverlayStyle]="{
                display:
                  sourcesDataCopy.statements.STD.join(', ').length > 80
                    ? 'inherit'
                    : 'none',
                fontSize: '11px',
                padding: '0px',
                background: '#999'
              }"
            >
              STD:
              {{ sourcesDataCopy.statements.STD.join(", ") | textEllipsis: 80 }}
            </span>
            <span
              *ngIf="sourcesDataCopy.statements.NMV.length > 0"
              nz-tooltip
              nzTooltipTitle="{{ sourcesDataCopy.statements.NMV.join(', ') }}"
              nzTooltipPlacement="bottomLeft"
              nzTooltipMouseEnterDelay="14"
              [nzTooltipOverlayStyle]="{
                display:
                  sourcesDataCopy.statements.NMV.join(', ').length > 80
                    ? 'inherit'
                    : 'none',
                fontSize: '11px',
                padding: '0px',
                background: '#999'
              }"
            >
              NMV:
              {{ sourcesDataCopy.statements.NMV.join(", ") | textEllipsis: 80 }}
            </span>
            <span
              *ngIf="sourcesDataCopy.statements.SCH.length > 0"
              nz-tooltip
              nzTooltipTitle="{{ sourcesDataCopy.statements.SCH.join(', ') }}"
              nzTooltipPlacement="bottomLeft"
              nzTooltipMouseEnterDelay="14"
              [nzTooltipOverlayStyle]="{
                display:
                  sourcesDataCopy.statements.SCH.join(', ').length > 80
                    ? 'inherit'
                    : 'none',
                fontSize: '11px',
                padding: '0px',
                background: '#999'
              }"
            >
              SCH:
              {{ sourcesDataCopy.statements.SCH.join(", ") | textEllipsis: 80 }}
            </span>
            <span
              *ngFor="let entry of sourcesDataCopy.statements.SAR | keyvalue"
              nz-tooltip
              nzTooltipTitle="{{ entry.value.join(', ') }}"
              nzTooltipPlacement="bottomLeft"
              nzTooltipMouseEnterDelay="14"
              [nzTooltipOverlayStyle]="{
                display:
                  entry.value.join(', ').length > 80 ? 'inherit' : 'none',
                fontSize: '11px',
                padding: '0px',
                background: '#999'
              }"
            >
              {{ entry.key }}: {{ entry.value.join(", ") | textEllipsis: 80 }}
            </span>
          </div>
          <div class="current-settings-subsection">
            <span class="preset-subheader">Sources:</span>
            <span *ngIf="sourcesDataCopy && sourcesDataCopy.AllSourceData">
              {{ sourcesDataCopy.AllSourceData.ConsensusType.join(", ") }}
              and Historicals:
              {{ sourcesDataCopy.AllSourceData.va_actuals ? "VA Actuals" : "" }}
              {{ sourcesDataCopy.AllSourceData.filings ? ", Filings" : "" }}
              {{
                sourcesDataCopy.AllSourceData.historical_consensus
                  ? ", Consensus"
                  : ""
              }}
            </span>
            <span>Sources in {{ sourcesDataCopy.type }}</span>
          </div>
          <div class="current-settings-subsection">
            <span class="preset-subheader">Time Periods</span>
            <span
              >{{ noOfReportedYears }} reported years and
              {{ noOfForecastYears }} forecast years</span
            >
            <span
              >Order of Annuals and Interims:
              {{ periodsDataCopy.AandQOrder }}</span
            >
          </div>
          <div class="current-settings-subsection">
            <span class="preset-subheader">Historical Estimates:</span>
            <span>{{ revisionsDataCopy.values | nullCleaner }}</span>
            <span>Revision in {{ revisionsDataCopy.type }}</span>
          </div>
          <div class="current-settings-subsection">
            <span class="preset-subheader">Analytics (Labs):</span>
            <span>{{ analyticsDataCopy.values.join(", ") }}</span>
          </div>
        </div>
      </div>
    </ng-template>
    <!-- ============================================================ -->
    <!-- current settings template start -->
    <!-- ============================================================ -->

    <!-- ============================================================ -->
    <!-- statements template start -->
    <!-- ============================================================ -->
    <ng-template #statementsContent>
      <div class="statements-content">
        <span class="preset-header">Statements</span>
        <div
          class="checkbox-split-statements"
          [class.disable]="sourcesDataCopy.type === 'tab'"
        >
          <label
            class="checkbox-sm"
            nz-checkbox
            [(ngModel)]="extrasDataCopy.splitIntoTabs"
            >Split Statement into Tabs</label
          >
        </div>
        <div class="divider"></div>
        <div class="content-inner">
          <div class="statements-tree-container">
            <nz-tree
              #allStatementsTree
              [nzData]="allStatements"
              nzCheckable
              (nzCheckBoxChange)="nzCheck($event, false)"
            >
            </nz-tree>

            <p class="subsection-header">Analyst Published Models</p>
            <nz-tree
              #allBrokersExcluedAndNonTree
              [nzData]="allBrokersExcluedAndNon"
              nzCheckable
              (nzCheckBoxChange)="nzCheck($event, true)"
            >
            </nz-tree>
          </div>
        </div>
      </div>
    </ng-template>
    <!-- ============================================================ -->
    <!-- statements template end -->
    <!-- ============================================================ -->

    <!-- ============================================================ -->
    <!-- sources template start -->
    <!-- ============================================================ -->
    <ng-template #sourcesContent>
      <div class="sources-content">
        <span class="preset-header">Sources</span>
        <div class="divider"></div>
        <div class="content-inner">
          <div class="sources-placement">
            <span class="preset-subheader">Placement</span>
            <nz-radio-group
              [(ngModel)]="sourcesDataCopy.type"
              [nzButtonStyle]="'solid'"
              [nzSize]="'small'"
              (ngModelChange)="onSourcePlacementChange($event)"
            >
              <label nz-radio-button nzValue="column">Columns</label>
              <label nz-radio-button nzValue="row">Rows</label>
              <label nz-radio-button nzValue="tab">Tabs</label>
            </nz-radio-group>
          </div>

          <div nz-row nzGutter="8">
            <div nz-col nzSpan="16">
              <span class="preset-header">Sources for All Statements</span>
              <div class="sources-grid">
                <span class="preset-subheader">Calculated Sources</span>
                <div class="checkbox-group">
                  <label
                    *ngIf="allowedComputedSources.includes('Consensus+')"
                    class="checkbox-sm"
                    nz-checkbox
                    [ngModel]="
                      sourcesDataCopy.AllSourceData.ConsensusType.includes(
                        'Consensus+'
                      )
                    "
                    (ngModelChange)="
                      toggleComputedSources('Consensus+', $event)
                    "
                    >Consensus
                    <span>
                      <va-icon
                        name="plus"
                        style="color: #f2883d; zoom: 0.9"
                      ></va-icon> </span
                  ></label>
                  <label
                    *ngIf="allowedComputedSources.includes('Consensus')"
                    class="checkbox-sm"
                    nz-checkbox
                    [ngModel]="
                      sourcesDataCopy.AllSourceData.ConsensusType.includes(
                        'Consensus'
                      )
                    "
                    (ngModelChange)="toggleComputedSources('Consensus', $event)"
                    >Consensus</label
                  >
                  <label
                    *ngIf="allowedComputedSources.includes('Custom')"
                    class="checkbox-sm"
                    nz-checkbox
                    [nzDisabled]="disableCustomConsensus"
                    [ngModel]="
                      sourcesDataCopy.AllSourceData.ConsensusType.includes(
                        'Custom'
                      )
                    "
                    (ngModelChange)="toggleComputedSources('Custom', $event)"
                    >Custom Consensus
                    <span
                      ><img src="{{ assets }}/custom_consensus.png" alt=""
                    /></span>
                  </label>
                </div>

                <span class="preset-subheader">Brokers</span>
                <span class="show-only-current-switch"
                  ><label>Show Only Current</label
                  ><nz-switch
                    nzSize="small"
                    [ngModel]="sourcesDataCopy.AllSourceData.Show_Only_Current"
                    (ngModelChange)="onShowCurrentSwitch($event)"
                  ></nz-switch
                ></span>

                <div>
                  <nz-table
                    #sortTable
                    [nzData]="brokersList"
                    nzFrontPagination="false"
                    [nzScroll]="{ y: '156px' }"
                  >
                    <thead (nzSortChange)="onSortChange($event)">
                      <tr>
                        <th
                          class="checkbox-extra-sm"
                          [nzShowCheckbox]="true"
                          [nzIndeterminate]="
                            sourcesDataCopy.AllSourceData.SelectedSources
                              .length !== brokersList.length &&
                            sourcesDataCopy.AllSourceData.SelectedSources
                              .length > 0
                          "
                          (nzCheckedChange)="onCheckAll($event)"
                          nzWidth="30px"
                        ></th>
                        <th nzWidth="150px" [nzSortFn]="undefined">Brokers</th>
                        <th nzWidth="150px">Analyst</th>
                        <th [nzSortFn]="undefined">Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="let row of brokersList"
                        [ngClass]="row.focus ? 'row-disabled' : ''"
                      >
                        <td
                          class="checkbox-extra-sm"
                          [nzShowCheckbox]="true"
                          [nzChecked]="
                            sourcesDataCopy.AllSourceData.SelectedSources.includes(
                              row.sourceid
                            )
                          "
                          (nzCheckedChange)="onRowChecked(row.sourceid, $event)"
                          [ngClass]="row.focus ? 'disable-checkbox' : ''"
                        ></td>
                        <td>
                          <app-source-name-table-display
                            [brokerItem]="row"
                            [showCurrentViewInfo]="
                              restricted_broker.includes(row.sourceid) ||
                              dropped_broker.includes(row.sourceid)
                            "
                            [currentState]="
                              sourcesDataCopy.AllSourceData.SelectedSources.includes(
                                row.sourceid
                              )
                            "
                            (nameClicked)="
                              onRowChecked($event.id, $event.selected)
                            "
                          ></app-source-name-table-display>
                        </td>
                        <td
                          nz-tooltip
                          nzTooltipTitle="{{ row.analystname }}"
                          nzTooltipPlacement="bottomLeft"
                          nzTooltipMouseEnterDelay="14"
                          [nzTooltipOverlayStyle]="{
                            display:
                              row.analystname.length > 19 ? 'inherit' : 'none',
                            fontSize: '11px',
                            padding: '0px',
                            background: '#999'
                          }"
                        >
                          {{ row.analystname | textEllipsis: 19 }}
                        </td>
                        <td>{{ row.modeldate }}</td>
                      </tr>
                    </tbody>
                  </nz-table>
                </div>
              </div>
            </div>
            <div nz-col nzSpan="8">
              <span class="preset-header">Additional Options</span>
              <div class="additional-options">
                <span class="preset-subheader">Historicals</span>
                <div class="checkbox-group">
                  <label
                    class="checkbox-sm"
                    nz-checkbox
                    [ngModel]="
                      sourcesDataCopy.AllSourceData.historical_consensus
                    "
                    (ngModelChange)="
                      onChangeHistoricals('historical_consensus', $event)
                    "
                    >Consensus</label
                  >
                  <label
                    class="checkbox-sm"
                    nz-checkbox
                    [ngModel]="sourcesDataCopy.AllSourceData.filings"
                    (ngModelChange)="onChangeHistoricals('filings', $event)"
                    >Filings (Last Date {{ lastFilingsDate }})</label
                  >
                  <label
                    class="checkbox-sm"
                    nz-checkbox
                    [ngModel]="sourcesDataCopy.AllSourceData.va_actuals"
                    (ngModelChange)="onChangeHistoricals('va_actuals', $event)"
                    >VA Actuals</label
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <!-- ============================================================ -->
    <!-- sources template end -->
    <!-- ============================================================ -->

    <!-- ============================================================ -->
    <!-- time period template start -->
    <!-- ============================================================ -->
    <ng-template #timeperiodsContent>
      <div class="timeperiods-content">
        <span class="preset-header">Time Periods</span>
        <div class="divider"></div>

        <div class="content-inner">
          <div class="availability-display" nz-row>
            <div nz-col nzSpan="5">
              <span class="preset-subheader">Periods Available</span>
              <span class="preset-subheader">Latest Filings</span>
            </div>
            <div nz-col nzSpan="10">
              <span class="preset-subheader-value"
                >{{ periodsDataCopy.selected_from }} to
                {{ periodsDataCopy.selected_to }}</span
              >
              <span class="preset-subheader-value">{{
                periodsDataCopy.currentquarter
              }}</span>
            </div>
          </div>

          <div class="year-range-setter" nz-row>
            <div nz-col nzSpan="8">
              <span class="preset-subheader">Number of Reported Years</span>
              <span class="preset-subheader">Number of Forecast Years</span>
            </div>
            <div nz-col nzSpan="12">
              <select
                class="preset-subheader-value"
                [ngModel]="noOfReportedYears"
                (ngModelChange)="
                  onPeriodRangeChanged({
                    reported: $event,
                    forecast: undefined
                  })
                "
              >
                <option *ngFor="let n of noOfYearsReported" [value]="n">
                  {{ n }}
                </option>
              </select>
              <select
                class="preset-subheader-value"
                [ngModel]="noOfForecastYears"
                (ngModelChange)="
                  onPeriodRangeChanged({
                    forecast: $event,
                    reported: undefined
                  })
                "
              >
                <option *ngFor="let n of noOfYearsForecast" [value]="n">
                  {{ n }}
                </option>
              </select>
            </div>
          </div>

          <div class="ai-radio-group">
            <span class="preset-subheader">Display</span>
            <nz-radio-group
              [ngModel]="
                (periodsDataCopy.annuals ? 'A' : '') +
                (periodsDataCopy.interims ? 'I' : '')
              "
              (ngModelChange)="changeAiInclusion($event)"
            >
              <label nz-radio nzValue="A">Annuals</label>
              <label nz-radio nzValue="I">Interims</label>
              <label nz-radio nzValue="AI">Annuals and Interims</label>
            </nz-radio-group>
          </div>

          <div
            class="ai-order"
            *ngIf="periodsDataCopy.annuals && periodsDataCopy.interims"
          >
            <span class="preset-subheader">Order of Annuals and Interims</span>
            <nz-radio-group
              [(ngModel)]="periodsDataCopy.AandQOrder"
              [nzButtonStyle]="'solid'"
              [nzSize]="'small'"
            >
              <label nz-radio-button nzValue="IAIA">IAIA</label>
              <label nz-radio-button nzValue="AIAI">AIAI</label>
              <label nz-radio-button nzValue="IIAA">IIAA</label>
              <label nz-radio-button nzValue="AAII">AAII</label>
            </nz-radio-group>
          </div>
        </div>
      </div>
    </ng-template>
    <!-- ============================================================ -->
    <!-- time period template end -->
    <!-- ============================================================ -->

    <!-- ============================================================ -->
    <!-- Historical Estimates template start -->
    <!-- ============================================================ -->
    <ng-template #historicalEstimatesContent>
      <div class="historical-estimates-content">
        <span class="preset-header">Historical Estimates</span>
        <div class="divider"></div>

        <div class="content-inner">
          <div>
            <span class="preset-subheader">Consensus</span>
            <nz-radio-group
              [(ngModel)]="revisionsDataCopy.type"
              [nzButtonStyle]="'solid'"
              [nzSize]="'small'"
              (ngModelChange)="onSourcePlacementChange($event)"
            >
              <label nz-radio-button nzValue="column">Columns</label>
              <label nz-radio-button nzValue="row">Rows</label>
              <label nz-radio-button nzValue="tab">Tabs</label>
            </nz-radio-group>
          </div>

          <div class="info-text">
            <span>Historic periods are anchored on the announcement date.</span
            ><br />
            <span>Estimates are anchored on today's date.</span>
          </div>

          <div class="checkbox-group">
            <label
              class="checkbox-sm"
              nz-checkbox
              [ngModel]="preqChecked"
              (ngModelChange)="onPreqChange($event)"
              >PreQ (prior to earnings)</label
            >
          </div>

          <div
            class="revision-container"
            *ngFor="
              let date of datePickerModel;
              index as i;
              trackBy: trackByIdx
            "
          >
            <ng-template #effectiveStartTemplate>
              <span>
                <label>Revisions available from:</label>
                <button
                  nz-button
                  nzType="link"
                  (click)="onEffectiveStartClick(i)"
                  style="padding: 0px 4px"
                >
                  {{ revisionsDataCopy.effectiveStart }}
                </button>
              </span>
            </ng-template>

            <div class="export-revision-date-picker">
              <nz-date-picker
                [nzSize]="'small'"
                [nzPlaceHolder]="'yyyy-mm-dd'"
                [nzDisabledDate]="disabledDate"
                [nzShowToday]="false"
                [(ngModel)]="datePickerModel[i]"
                (ngModelChange)="onDateChange($event, i)"
                [nzRenderExtraFooter]="effectiveStartTemplate"
                [class.date-error]="errorArray[i] !== ''"
              ></nz-date-picker>
              <div
                *ngIf="i > 0"
                class="btn-remove-revision"
                (click)="removeRevision(i)"
              >
                <va-icon name="close"></va-icon>
              </div>
              <div *ngIf="i === 0" class="info-icon-max-revisions">
                <va-icon size="small" name="info-circle"></va-icon>
                <span>Maximum 5 revisions can be set</span>
              </div>
            </div>
            <span
              class="checkbox-line"
              *ngIf="revisionsDataCopy.values[i] !== null"
              >Relative date: {{ revisionsDataCopy.values[i] }}</span
            >
            <span class="checkbox-line error-color">{{ errorArray[i] }}</span>
          </div>

          <va-icon
            size="small"
            class="btn-add-revision"
            name="plus"
            (click)="addRevision()"
            *ngIf="datePickerModel.length < 5"
          ></va-icon>
        </div>
      </div>
    </ng-template>
    <!-- ============================================================ -->
    <!-- Historical Estimates template end -->
    <!-- ============================================================ -->

    <!-- ============================================================ -->
    <!-- accounting template start -->
    <!-- ============================================================ -->
    <ng-template #accountingContent>
      <div class="accounting-content">
        <span class="preset-header">Accounting</span>
        <div class="divider"></div>
      </div>

      <div class="content-inner">
        <div nz-row>
          <div nz-col nzSpan="6">
            <span class="preset-subheader">Basis</span>
            <nz-radio-group
              [(ngModel)]="accountingDataCopy.selectedBasis"
              [nzSize]="'small'"
            >
              <label nz-radio nzValue="All">All</label>
              <label nz-radio nzValue="Operating">Operating</label>
              <label nz-radio nzValue="GAAP">GAAP</label>
            </nz-radio-group>
          </div>
          <div nz-col nzSpan="6">
            <span class="preset-subheader">Missing Data</span>
            <nz-radio-group [ngModel]="'implied'">
              <label nz-radio nzValue="implied">Include Inferred Data</label>
            </nz-radio-group>
          </div>
        </div>
      </div>
    </ng-template>
    <!-- ============================================================ -->
    <!-- accounting template end -->
    <!-- ============================================================ -->

    <!-- ============================================================ -->
    <!-- analytics template start -->
    <!-- ============================================================ -->
    <ng-template #analyticsContent>
      <div class="analytics-content">
        <span class="preset-header">Analytics (Labs)</span>
        <div class="divider"></div>

        <div class="content-inner">
          <h4>Growth</h4>

          <div class="checkbox-group">
            <label
              class="checkbox-sm"
              nz-checkbox
              [ngModel]="analyticsDataCopy.values.includes('YoY%')"
              (ngModelChange)="changeAnalyticInclusion('YoY%', $event)"
              >Year over Year (%)</label
            >
            <label
              class="checkbox-sm"
              nz-checkbox
              [ngModel]="analyticsDataCopy.values.includes('YoY#')"
              (ngModelChange)="changeAnalyticInclusion('YoY#', $event)"
              >Year over Year (#)</label
            >
            <label
              class="checkbox-sm"
              nz-checkbox
              [ngModel]="analyticsDataCopy.values.includes('Seq%')"
              (ngModelChange)="changeAnalyticInclusion('Seq%', $event)"
              >Sequential growth (%)</label
            >
            <label
              class="checkbox-sm"
              nz-checkbox
              [ngModel]="analyticsDataCopy.values.includes('Seq#')"
              (ngModelChange)="changeAnalyticInclusion('Seq#', $event)"
              >Sequential growth (#)</label
            >
            <div>
              <label
                class="checkbox-sm"
                nz-checkbox
                [ngModel]="analyticsDataCopy.values.includes('Trend')"
                (ngModelChange)="changeAnalyticInclusion('Trend', $event)"
                >Compare to (%)</label
              >
              <select [(ngModel)]="analyticsDataCopy.trendYear">
                <option
                  *ngFor="let yearItem of analyticsYearlist"
                  [value]="yearItem.year"
                >
                  FY-{{ yearItem.label }}
                </option>
              </select>
            </div>
            <label
              class="checkbox-sm"
              nz-checkbox
              [ngModel]="analyticsDataCopy.values.includes('%')"
              (ngModelChange)="changeAnalyticInclusion('%', $event)"
              >As a percent of</label
            >
          </div>
        </div>
      </div>
    </ng-template>
    <!-- ============================================================ -->
    <!-- analytics template end -->
    <!-- ============================================================ -->
  </ng-container>
</nz-modal>
